import { CoordinateCardPopProps } from "@/types/type";
import { router } from "expo-router";
import React from "react";
import { Text, TouchableOpacity, View } from "react-native";

const Coordinate = ({
  coordinate,
  additionalStyling,
  style,
}: CoordinateCardPopProps) => {
  const basicStyling = "bg-white p-3 rounded-2xl  flex-row items-center";
  const styling = style ? style : basicStyling;

  return (
    <View className={`${styling} ${additionalStyling}`}>
      {/* <Text className="text-gray-500 text-xs flex-1">
            {`${coordinate.latitude}, ${coordinate.longitude}`}
          </Text> */}
      <TouchableOpacity
        onPress={() => router.push("./../post-create")}
        className="bg-blue-500 py-1 px-3 rounded-lg m-1"
      >
        <Text className="text-white text-xs">Create Post</Text>
      </TouchableOpacity>

      <TouchableOpacity
        onPress={() => router.push("./../place-create")}
        className="bg-blue-500 py-1 px-3 rounded-lg m-1"
      >
        <Text className="text-white text-xs">Create Place</Text>
      </TouchableOpacity>
    </View>
  );
};

export default Coordinate;
